import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { ConnectedConfiguratorScreen } from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen";
import { DesignerScreen } from "@configuratorware/configurator-frontendgui/App/Modules/Designer/DesignerScreen";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import FullScreenViewContainer from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/FullScreenView";
import VisualizationContainer from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/Visualization";
import NoVisualization from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Components/NoVisualization/NoVisualization";
import AddVisualElement from "@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/AddVisualElement";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import CustomAmountPriceContainer from "../Containers/AmountPrice/AmountPrice";
import ConfigurationRestrictor from "../Components/ConfigurationRestrictor/ConfigurationRestrictor";
import CustomHeader from "../Containers/CustomHeader";
import CustomThemeProvider from "../ThemeProvider";
import CustomImageEditDialogContainer from "../Containers/ImageEditDialog/ImageEditDialog";
import ProductVariant from "../Containers/ProductVariant/ProductVariant";
import Designer from "../Containers/Designer/Designer";
import CustomProductPartsList from "../Containers/CustomProductPartsListContainer";
import FreePositionCheck from "../Components/FreePositionCheck";
import CustomCreatorScreen from "./CustomCreatorScreen";

const CustomDesignerScreen = (props) => {
  const renderImageEditDialog = () => {
    return <CustomImageEditDialogContainer />;
  };
  return (
    <div>
      <DesignerScreen
        renderImageEditDialog={renderImageEditDialog}
        renderAddVisualElement={() => (
          <FreePositionCheck>
            <AddVisualElement autoHide />
          </FreePositionCheck>
        )}
        {...props}
      />
    </div>
  );
};



export default (props) => {
  const loadCode = useSelector((state) =>
    get(state, "configurator.loadCode", null)
  );
  const status = useSelector((state) =>
    get(state, "configurator.configuration.status", null)
  );
  const loadedFromList = useSelector((state) =>
    get(state, "basket.configurationFromList", false)
  );
  const token = useSelector((state) =>
    get(state, "login.token", null)
  );
  const [restrictConfiguration, setRestrictConfiguration] = useState(false);
  const [externalAccess, setExternalAccess] = useState(false);
  const [showRestrictor, setShowRestrictor] = useState(false);

  useEffect(() => {
    token && Api.setTokenHeader(token)
  }, [token]);

  const itemIdentifier = useSelector(
    // @ts-ignore
    (state) => state.configurator.configuration.item.identifier
  );

  // @ts-ignore
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);

  useEffect(() => {
    if (
      loadCode &&
      status &&
      (status === "reorderable" || status === "inactive")
    ) {
      setRestrictConfiguration(true);
      setShowRestrictor(true);
      Services.designData.toggleHighlight(false);
      if (!loadedFromList) {
        setExternalAccess(true);
      }
    } else {
      setRestrictConfiguration(false);
      setShowRestrictor(false);
    }
  }, [status]);

  const renderProductParts = (
    dispatchAction,
    onOptionClassificationSelect,
    selectOptionClassification
  ) => {
    return (
      <CustomProductPartsList
        onSelect={(optionClassification) =>
          onOptionClassificationSelect(
            dispatchAction,
            optionClassification,
            selectOptionClassification
          )
        }
      />
    );
  };
  const renderVisualization = ({ Props }) => (
    <>
      <FullScreenViewContainer {...Props}>
        <React.Suspense
          fallback={<div>Loading Visualization Component...</div>}
        >
          <VisualizationContainer BrokenComponent={NoVisualization} />
        </React.Suspense>
      </FullScreenViewContainer>
    </>
  );

  return (
    <>
      {showRestrictor && (
        <ConfigurationRestrictor
          status={status}
          externalAccess={externalAccess}
          onClose={() => setShowRestrictor(false)}
        />
      )}
      <div
        style={{
          display:
            loadCode &&
            (status === "inactive" ||
              (status === "reorderable" && externalAccess))
              ? "none"
              : "block",
        }}
      >
        <ConnectedConfiguratorScreen
          {...props}
          renderAmountPrice={(props) =>
            <CustomAmountPriceContainer
              {...props}
              showConfigurationModeSwitch={
                restrictConfiguration || !isLoggedIn
                  ? false
                  : props.showConfigurationModeSwitch
              }
              ProductVariantComponent={ProductVariant}
            />
          }
          renderHeader={() => <CustomHeader />}
          ThemeProvider={CustomThemeProvider}
          DesignerScreen={CustomDesignerScreen}
          renderProductParts={renderProductParts}
          CreatorScreen={CustomCreatorScreen}
          renderDesigner={() => (
            <React.Suspense fallback={<div>Loading Designer Component...</div>}>
              <Designer />
            </React.Suspense>
          )}
          renderVisualization={renderVisualization}
        />
      </div>
    </>
  );
};
